@file:OptIn(InternalResourceApi::class)

package portalvv.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/portalvv.shared.generated.resources/"

@delegate:ResourceContentHash(-825_428_031)
internal val Res.string.rmp_filter_all_stages: StringResource by lazy {
      StringResource("string:rmp_filter_all_stages", "rmp_filter_all_stages", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85926, 49),
      ))
    }

@delegate:ResourceContentHash(958_060_264)
internal val Res.string.rmp_filter_all_types: StringResource by lazy {
      StringResource("string:rmp_filter_all_types", "rmp_filter_all_types", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85976, 48),
      ))
    }

@delegate:ResourceContentHash(845_341_347)
internal val Res.string.rmp_filter_all_units: StringResource by lazy {
      StringResource("string:rmp_filter_all_units", "rmp_filter_all_units", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86025, 52),
      ))
    }

@delegate:ResourceContentHash(-1_606_047_788)
internal val Res.string.rmp_filter_clear: StringResource by lazy {
      StringResource("string:rmp_filter_clear", "rmp_filter_clear", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86078, 44),
      ))
    }

@delegate:ResourceContentHash(1_040_542_690)
internal val Res.string.rmp_filter_from: StringResource by lazy {
      StringResource("string:rmp_filter_from", "rmp_filter_from", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86123, 35),
      ))
    }

@delegate:ResourceContentHash(2_120_664_837)
internal val Res.string.rmp_filter_my_pending: StringResource by lazy {
      StringResource("string:rmp_filter_my_pending", "rmp_filter_my_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86159, 53),
      ))
    }

@delegate:ResourceContentHash(-1_942_490_813)
internal val Res.string.rmp_filter_to: StringResource by lazy {
      StringResource("string:rmp_filter_to", "rmp_filter_to", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86213, 37),
      ))
    }

@delegate:ResourceContentHash(1_628_950_473)
internal val Res.string.rmp_missing_fields: StringResource by lazy {
      StringResource("string:rmp_missing_fields", "rmp_missing_fields", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86474, 90),
      ))
    }

@delegate:ResourceContentHash(921_106_325)
internal val Res.string.rmp_missing_fields_ask: StringResource by lazy {
      StringResource("string:rmp_missing_fields_ask", "rmp_missing_fields_ask", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86251, 110),
      ))
    }

@delegate:ResourceContentHash(-389_760_601)
internal val Res.string.rmp_missing_fields_edit: StringResource by lazy {
      StringResource("string:rmp_missing_fields_edit", "rmp_missing_fields_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86362, 111),
      ))
    }

@delegate:ResourceContentHash(177_734_343)
internal val Res.string.rmp_new_attach: StringResource by lazy {
      StringResource("string:rmp_new_attach", "rmp_new_attach", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86723, 38),
      ))
    }

@delegate:ResourceContentHash(-1_715_516_135)
internal val Res.string.rmp_new_attach_pending: StringResource by lazy {
      StringResource("string:rmp_new_attach_pending", "rmp_new_attach_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86565, 42),
      ))
    }

@delegate:ResourceContentHash(-1_498_159_073)
internal val Res.string.rmp_new_attach_unsupported: StringResource by lazy {
      StringResource("string:rmp_new_attach_unsupported", "rmp_new_attach_unsupported", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86608, 114),
      ))
    }

@delegate:ResourceContentHash(1_619_027_694)
internal val Res.string.rmp_new_back: StringResource by lazy {
      StringResource("string:rmp_new_back", "rmp_new_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86762, 40),
      ))
    }

@delegate:ResourceContentHash(-425_991_515)
internal val Res.string.rmp_new_date_placeholder: StringResource by lazy {
      StringResource("string:rmp_new_date_placeholder", "rmp_new_date_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86803, 48),
      ))
    }

@delegate:ResourceContentHash(-339_481_958)
internal val Res.string.rmp_new_month_end: StringResource by lazy {
      StringResource("string:rmp_new_month_end", "rmp_new_month_end", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86852, 41),
      ))
    }

@delegate:ResourceContentHash(-97_381_183)
internal val Res.string.rmp_new_month_start: StringResource by lazy {
      StringResource("string:rmp_new_month_start", "rmp_new_month_start", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86894, 43),
      ))
    }

@delegate:ResourceContentHash(-75_555_106)
internal val Res.string.rmp_new_no_units: StringResource by lazy {
      StringResource("string:rmp_new_no_units", "rmp_new_no_units", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86938, 156),
      ))
    }

@delegate:ResourceContentHash(1_036_310_648)
internal val Res.string.rmp_new_required_hint: StringResource by lazy {
      StringResource("string:rmp_new_required_hint", "rmp_new_required_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87095, 125),
      ))
    }

@delegate:ResourceContentHash(-1_352_498_560)
internal val Res.string.rmp_new_select_placeholder: StringResource by lazy {
      StringResource("string:rmp_new_select_placeholder", "rmp_new_select_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87221, 58),
      ))
    }

@delegate:ResourceContentHash(-1_648_534_997)
internal val Res.string.rmp_new_submit: StringResource by lazy {
      StringResource("string:rmp_new_submit", "rmp_new_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87280, 30),
      ))
    }

@delegate:ResourceContentHash(-796_798_858)
internal val Res.string.rmp_new_subtitle: StringResource by lazy {
      StringResource("string:rmp_new_subtitle", "rmp_new_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87311, 116),
      ))
    }

@delegate:ResourceContentHash(1_092_620_219)
internal val Res.string.rmp_new_title: StringResource by lazy {
      StringResource("string:rmp_new_title", "rmp_new_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87428, 49),
      ))
    }

@delegate:ResourceContentHash(1_893_655_254)
internal val Res.string.rmp_new_type: StringResource by lazy {
      StringResource("string:rmp_new_type", "rmp_new_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87539, 48),
      ))
    }

@delegate:ResourceContentHash(403_335_505)
internal val Res.string.rmp_new_type_placeholder: StringResource by lazy {
      StringResource("string:rmp_new_type_placeholder", "rmp_new_type_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87478, 60),
      ))
    }

@delegate:ResourceContentHash(81_016_031)
internal val Res.string.rmp_report_admission: StringResource by lazy {
      StringResource("string:rmp_report_admission", "rmp_report_admission", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87588, 72),
      ))
    }

@delegate:ResourceContentHash(-1_143_065_647)
internal val Res.string.rmp_report_csv: StringResource by lazy {
      StringResource("string:rmp_report_csv", "rmp_report_csv", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87661, 50),
      ))
    }

@delegate:ResourceContentHash(-1_609_672_620)
internal val Res.string.rmp_report_general: StringResource by lazy {
      StringResource("string:rmp_report_general", "rmp_report_general", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87712, 42),
      ))
    }

@delegate:ResourceContentHash(677_886_556)
internal val Res.string.rmp_report_print: StringResource by lazy {
      StringResource("string:rmp_report_print", "rmp_report_print", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87755, 52),
      ))
    }

@delegate:ResourceContentHash(-1_412_338_793)
internal val Res.string.rmp_report_role_change: StringResource by lazy {
      StringResource("string:rmp_report_role_change", "rmp_report_role_change", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87808, 62),
      ))
    }

@delegate:ResourceContentHash(-2_014_258_253)
internal val Res.string.rmp_report_transfer: StringResource by lazy {
      StringResource("string:rmp_report_transfer", "rmp_report_transfer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87871, 55),
      ))
    }

@delegate:ResourceContentHash(128_763_250)
internal val Res.string.rmp_request_new: StringResource by lazy {
      StringResource("string:rmp_request_new", "rmp_request_new", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87927, 43),
      ))
    }

@delegate:ResourceContentHash(150_550_125)
internal val Res.string.rmp_required_actions: StringResource by lazy {
      StringResource("string:rmp_required_actions", "rmp_required_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88081, 56),
      ))
    }

@delegate:ResourceContentHash(2_046_823_144)
internal val Res.string.rmp_required_actions_who: StringResource by lazy {
      StringResource("string:rmp_required_actions_who", "rmp_required_actions_who", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87971, 64),
      ))
    }

@delegate:ResourceContentHash(-1_752_514_368)
internal val Res.string.rmp_required_actions_you: StringResource by lazy {
      StringResource("string:rmp_required_actions_you", "rmp_required_actions_you", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88036, 44),
      ))
    }

@delegate:ResourceContentHash(-989_284_405)
internal val Res.string.rmp_retry: StringResource by lazy {
      StringResource("string:rmp_retry", "rmp_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88138, 41),
      ))
    }

@delegate:ResourceContentHash(1_280_944_166)
internal val Res.string.rmp_search: StringResource by lazy {
      StringResource("string:rmp_search", "rmp_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88180, 114),
      ))
    }

@delegate:ResourceContentHash(243_070_068)
internal val Res.string.rmp_sync: StringResource by lazy {
      StringResource("string:rmp_sync", "rmp_sync", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91111, 32),
      ))
    }

@delegate:ResourceContentHash(515_583_929)
internal val Res.string.rmp_sync_cancel_edit: StringResource by lazy {
      StringResource("string:rmp_sync_cancel_edit", "rmp_sync_cancel_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88295, 40),
      ))
    }

@delegate:ResourceContentHash(1_539_054_651)
internal val Res.string.rmp_sync_col_actions: StringResource by lazy {
      StringResource("string:rmp_sync_col_actions", "rmp_sync_col_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88336, 40),
      ))
    }

@delegate:ResourceContentHash(1_040_542_822)
internal val Res.string.rmp_sync_col_created_at: StringResource by lazy {
      StringResource("string:rmp_sync_col_created_at", "rmp_sync_col_created_at", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88377, 43),
      ))
    }

@delegate:ResourceContentHash(388_079_882)
internal val Res.string.rmp_sync_col_destination_director: StringResource by lazy {
      StringResource("string:rmp_sync_col_destination_director", "rmp_sync_col_destination_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88484, 65),
      ))
    }

@delegate:ResourceContentHash(-1_981_067_241)
internal val Res.string.rmp_sync_col_destination_director_date: StringResource by lazy {
      StringResource("string:rmp_sync_col_destination_director_date", "rmp_sync_col_destination_director_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88421, 62),
      ))
    }

@delegate:ResourceContentHash(1_108_159_504)
internal val Res.string.rmp_sync_col_director: StringResource by lazy {
      StringResource("string:rmp_sync_col_director", "rmp_sync_col_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88597, 45),
      ))
    }

@delegate:ResourceContentHash(331_112_311)
internal val Res.string.rmp_sync_col_director_date: StringResource by lazy {
      StringResource("string:rmp_sync_col_director_date", "rmp_sync_col_director_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88550, 46),
      ))
    }

@delegate:ResourceContentHash(285_880_568)
internal val Res.string.rmp_sync_col_general_director: StringResource by lazy {
      StringResource("string:rmp_sync_col_general_director", "rmp_sync_col_general_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88706, 65),
      ))
    }

@delegate:ResourceContentHash(513_850_358)
internal val Res.string.rmp_sync_col_general_director_date: StringResource by lazy {
      StringResource("string:rmp_sync_col_general_director_date", "rmp_sync_col_general_director_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88643, 62),
      ))
    }

@delegate:ResourceContentHash(2_638_316)
internal val Res.string.rmp_sync_col_hr: StringResource by lazy {
      StringResource("string:rmp_sync_col_hr", "rmp_sync_col_hr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88813, 27),
      ))
    }

@delegate:ResourceContentHash(344_213_624)
internal val Res.string.rmp_sync_col_hr_date: StringResource by lazy {
      StringResource("string:rmp_sync_col_hr_date", "rmp_sync_col_hr_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88772, 40),
      ))
    }

@delegate:ResourceContentHash(2_556_910)
internal val Res.string.rmp_sync_col_id: StringResource by lazy {
      StringResource("string:rmp_sync_col_id", "rmp_sync_col_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88841, 27),
      ))
    }

@delegate:ResourceContentHash(1_875_060_300)
internal val Res.string.rmp_sync_col_requester: StringResource by lazy {
      StringResource("string:rmp_sync_col_requester", "rmp_sync_col_requester", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88869, 46),
      ))
    }

@delegate:ResourceContentHash(-1_720_241_764)
internal val Res.string.rmp_sync_col_status: StringResource by lazy {
      StringResource("string:rmp_sync_col_status", "rmp_sync_col_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88916, 35),
      ))
    }

@delegate:ResourceContentHash(1_350_968_497)
internal val Res.string.rmp_sync_col_type: StringResource by lazy {
      StringResource("string:rmp_sync_col_type", "rmp_sync_col_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88952, 33),
      ))
    }

@delegate:ResourceContentHash(1_326_493_253)
internal val Res.string.rmp_sync_col_unit: StringResource by lazy {
      StringResource("string:rmp_sync_col_unit", "rmp_sync_col_unit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88986, 37),
      ))
    }

@delegate:ResourceContentHash(925_028_166)
internal val Res.string.rmp_sync_confirm_row: StringResource by lazy {
      StringResource("string:rmp_sync_confirm_row", "rmp_sync_confirm_row", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89024, 48),
      ))
    }

@delegate:ResourceContentHash(-760_957_319)
internal val Res.string.rmp_sync_edit_row: StringResource by lazy {
      StringResource("string:rmp_sync_edit_row", "rmp_sync_edit_row", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89073, 33),
      ))
    }

@delegate:ResourceContentHash(-325_297_805)
internal val Res.string.rmp_sync_empty: StringResource by lazy {
      StringResource("string:rmp_sync_empty", "rmp_sync_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89195, 66),
      ))
    }

@delegate:ResourceContentHash(29_716_439)
internal val Res.string.rmp_sync_empty_adjusted: StringResource by lazy {
      StringResource("string:rmp_sync_empty_adjusted", "rmp_sync_empty_adjusted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89107, 87),
      ))
    }

@delegate:ResourceContentHash(1_927_103_120)
internal val Res.string.rmp_sync_hint: StringResource by lazy {
      StringResource("string:rmp_sync_hint", "rmp_sync_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89262, 589),
      ))
    }

@delegate:ResourceContentHash(75_410_107)
internal val Res.string.rmp_sync_no_suggestion: StringResource by lazy {
      StringResource("string:rmp_sync_no_suggestion", "rmp_sync_no_suggestion", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89852, 78),
      ))
    }

@delegate:ResourceContentHash(2_605_182)
internal val Res.string.rmp_sync_not_applicable: StringResource by lazy {
      StringResource("string:rmp_sync_not_applicable", "rmp_sync_not_applicable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89931, 35),
      ))
    }

@delegate:ResourceContentHash(-51_731_477)
internal val Res.string.rmp_sync_result: StringResource by lazy {
      StringResource("string:rmp_sync_result", "rmp_sync_result", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89967, 167),
      ))
    }

@delegate:ResourceContentHash(1_353_865_830)
internal val Res.string.rmp_sync_save_row: StringResource by lazy {
      StringResource("string:rmp_sync_save_row", "rmp_sync_save_row", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90135, 33),
      ))
    }

@delegate:ResourceContentHash(-749_612_519)
internal val Res.string.rmp_sync_search: StringResource by lazy {
      StringResource("string:rmp_sync_search", "rmp_sync_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90169, 63),
      ))
    }

@delegate:ResourceContentHash(1_579_546_841)
internal val Res.string.rmp_sync_status_em_andamento: StringResource by lazy {
      StringResource("string:rmp_sync_status_em_andamento", "rmp_sync_status_em_andamento", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90233, 52),
      ))
    }

@delegate:ResourceContentHash(-1_720_241_764)
internal val Res.string.rmp_sync_status_filter: StringResource by lazy {
      StringResource("string:rmp_sync_status_filter", "rmp_sync_status_filter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90286, 38),
      ))
    }

@delegate:ResourceContentHash(1_960_017_448)
internal val Res.string.rmp_sync_status_finalizados: StringResource by lazy {
      StringResource("string:rmp_sync_status_finalizados", "rmp_sync_status_finalizados", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90325, 51),
      ))
    }

@delegate:ResourceContentHash(609_332_074)
internal val Res.string.rmp_sync_status_rejeitados: StringResource by lazy {
      StringResource("string:rmp_sync_status_rejeitados", "rmp_sync_status_rejeitados", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90377, 50),
      ))
    }

@delegate:ResourceContentHash(-120_265_308)
internal val Res.string.rmp_sync_status_todos: StringResource by lazy {
      StringResource("string:rmp_sync_status_todos", "rmp_sync_status_todos", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90428, 37),
      ))
    }

@delegate:ResourceContentHash(-450_192_078)
internal val Res.string.rmp_sync_subtitle: StringResource by lazy {
      StringResource("string:rmp_sync_subtitle", "rmp_sync_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90466, 249),
      ))
    }

@delegate:ResourceContentHash(-38_788_087)
internal val Res.string.rmp_sync_suggested_option: StringResource by lazy {
      StringResource("string:rmp_sync_suggested_option", "rmp_sync_suggested_option", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90716, 57),
      ))
    }

@delegate:ResourceContentHash(-471_291_884)
internal val Res.string.rmp_sync_summary: StringResource by lazy {
      StringResource("string:rmp_sync_summary", "rmp_sync_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90774, 108),
      ))
    }

@delegate:ResourceContentHash(-1_533_156_161)
internal val Res.string.rmp_sync_tab_adjusted: StringResource by lazy {
      StringResource("string:rmp_sync_tab_adjusted", "rmp_sync_tab_adjusted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90883, 53),
      ))
    }

@delegate:ResourceContentHash(502_282_312)
internal val Res.string.rmp_sync_tab_pending: StringResource by lazy {
      StringResource("string:rmp_sync_tab_pending", "rmp_sync_tab_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90937, 52),
      ))
    }

@delegate:ResourceContentHash(-1_656_650_058)
internal val Res.string.rmp_sync_title: StringResource by lazy {
      StringResource("string:rmp_sync_title", "rmp_sync_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90990, 34),
      ))
    }

@delegate:ResourceContentHash(1_821_127_249)
internal val Res.string.rmp_sync_unlinked: StringResource by lazy {
      StringResource("string:rmp_sync_unlinked", "rmp_sync_unlinked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91025, 41),
      ))
    }

@delegate:ResourceContentHash(1_498_131_784)
internal val Res.string.rmp_syncing: StringResource by lazy {
      StringResource("string:rmp_syncing", "rmp_syncing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91067, 43),
      ))
    }

@delegate:ResourceContentHash(1_579_546_841)
internal val Res.string.rmp_tab_in_progress: StringResource by lazy {
      StringResource("string:rmp_tab_in_progress", "rmp_tab_in_progress", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91144, 43),
      ))
    }

@delegate:ResourceContentHash(-1_671_699_800)
internal val Res.string.rmp_tab_unit_history: StringResource by lazy {
      StringResource("string:rmp_tab_unit_history", "rmp_tab_unit_history", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91188, 56),
      ))
    }

@delegate:ResourceContentHash(630_306_534)
internal val Res.string.rmp_tab_user_history: StringResource by lazy {
      StringResource("string:rmp_tab_user_history", "rmp_tab_user_history", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91245, 60),
      ))
    }

@delegate:ResourceContentHash(1_685_372_195)
internal val Res.string.rmp_test_approved: StringResource by lazy {
      StringResource("string:rmp_test_approved", "rmp_test_approved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91306, 37),
      ))
    }

@delegate:ResourceContentHash(-2_027_941_849)
internal val Res.string.rmp_test_convocation: StringResource by lazy {
      StringResource("string:rmp_test_convocation", "rmp_test_convocation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91344, 44),
      ))
    }

@delegate:ResourceContentHash(363_893_291)
internal val Res.string.rmp_test_convoke: StringResource by lazy {
      StringResource("string:rmp_test_convoke", "rmp_test_convoke", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91460, 48),
      ))
    }

@delegate:ResourceContentHash(-1_446_209_761)
internal val Res.string.rmp_test_convoke_title: StringResource by lazy {
      StringResource("string:rmp_test_convoke_title", "rmp_test_convoke_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91389, 70),
      ))
    }

@delegate:ResourceContentHash(1_970_082_135)
internal val Res.string.rmp_test_empty: StringResource by lazy {
      StringResource("string:rmp_test_empty", "rmp_test_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91509, 194),
      ))
    }

@delegate:ResourceContentHash(102_878_238)
internal val Res.string.rmp_test_failed: StringResource by lazy {
      StringResource("string:rmp_test_failed", "rmp_test_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91704, 35),
      ))
    }

@delegate:ResourceContentHash(1_685_164_283)
internal val Res.string.rmp_test_mark_approved: StringResource by lazy {
      StringResource("string:rmp_test_mark_approved", "rmp_test_mark_approved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91740, 42),
      ))
    }

@delegate:ResourceContentHash(102_878_863)
internal val Res.string.rmp_test_mark_failed: StringResource by lazy {
      StringResource("string:rmp_test_mark_failed", "rmp_test_mark_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91783, 40),
      ))
    }

@delegate:ResourceContentHash(2_136_458_116)
internal val Res.string.rmp_test_pending: StringResource by lazy {
      StringResource("string:rmp_test_pending", "rmp_test_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91824, 52),
      ))
    }

@delegate:ResourceContentHash(-523_397_172)
internal val Res.string.rmp_test_section: StringResource by lazy {
      StringResource("string:rmp_test_section", "rmp_test_section", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91877, 44),
      ))
    }

@delegate:ResourceContentHash(750_889_258)
internal val Res.string.rmp_test_send: StringResource by lazy {
      StringResource("string:rmp_test_send", "rmp_test_send", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91922, 33),
      ))
    }

@delegate:ResourceContentHash(-1_156_160_073)
internal val Res.string.rmp_test_time_placeholder: StringResource by lazy {
      StringResource("string:rmp_test_time_placeholder", "rmp_test_time_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91956, 41),
      ))
    }

@delegate:ResourceContentHash(2_636_662)
internal val Res.string.rmp_title: StringResource by lazy {
      StringResource("string:rmp_title", "rmp_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91998, 21),
      ))
    }

@delegate:ResourceContentHash(-1_048_810_972)
internal val Res.string.rmp_totals_status: StringResource by lazy {
      StringResource("string:rmp_totals_status", "rmp_totals_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92020, 49),
      ))
    }

@delegate:ResourceContentHash(760_205_340)
internal val Res.string.rmp_totals_type: StringResource by lazy {
      StringResource("string:rmp_totals_type", "rmp_totals_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92070, 43),
      ))
    }

@delegate:ResourceContentHash(-120_265_308)
internal val Res.string.rmp_type_all: StringResource by lazy {
      StringResource("string:rmp_type_all", "rmp_type_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92114, 28),
      ))
    }

@delegate:ResourceContentHash(1_637_190_751)
internal val Res.string.rmp_type_alteracao: StringResource by lazy {
      StringResource("string:rmp_type_alteracao", "rmp_type_alteracao", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92143, 42),
      ))
    }

@delegate:ResourceContentHash(714_931_433)
internal val Res.string.rmp_type_desligamento: StringResource by lazy {
      StringResource("string:rmp_type_desligamento", "rmp_type_desligamento", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92186, 45),
      ))
    }

@delegate:ResourceContentHash(1_350_968_497)
internal val Res.string.rmp_type_filter: StringResource by lazy {
      StringResource("string:rmp_type_filter", "rmp_type_filter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92232, 31),
      ))
    }

@delegate:ResourceContentHash(-191_381_064)
internal val Res.string.rmp_type_gratificacao: StringResource by lazy {
      StringResource("string:rmp_type_gratificacao", "rmp_type_gratificacao", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92264, 49),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString12Resources(map: MutableMap<String, StringResource>) {
  map.put("rmp_filter_all_stages", Res.string.rmp_filter_all_stages)
  map.put("rmp_filter_all_types", Res.string.rmp_filter_all_types)
  map.put("rmp_filter_all_units", Res.string.rmp_filter_all_units)
  map.put("rmp_filter_clear", Res.string.rmp_filter_clear)
  map.put("rmp_filter_from", Res.string.rmp_filter_from)
  map.put("rmp_filter_my_pending", Res.string.rmp_filter_my_pending)
  map.put("rmp_filter_to", Res.string.rmp_filter_to)
  map.put("rmp_missing_fields", Res.string.rmp_missing_fields)
  map.put("rmp_missing_fields_ask", Res.string.rmp_missing_fields_ask)
  map.put("rmp_missing_fields_edit", Res.string.rmp_missing_fields_edit)
  map.put("rmp_new_attach", Res.string.rmp_new_attach)
  map.put("rmp_new_attach_pending", Res.string.rmp_new_attach_pending)
  map.put("rmp_new_attach_unsupported", Res.string.rmp_new_attach_unsupported)
  map.put("rmp_new_back", Res.string.rmp_new_back)
  map.put("rmp_new_date_placeholder", Res.string.rmp_new_date_placeholder)
  map.put("rmp_new_month_end", Res.string.rmp_new_month_end)
  map.put("rmp_new_month_start", Res.string.rmp_new_month_start)
  map.put("rmp_new_no_units", Res.string.rmp_new_no_units)
  map.put("rmp_new_required_hint", Res.string.rmp_new_required_hint)
  map.put("rmp_new_select_placeholder", Res.string.rmp_new_select_placeholder)
  map.put("rmp_new_submit", Res.string.rmp_new_submit)
  map.put("rmp_new_subtitle", Res.string.rmp_new_subtitle)
  map.put("rmp_new_title", Res.string.rmp_new_title)
  map.put("rmp_new_type", Res.string.rmp_new_type)
  map.put("rmp_new_type_placeholder", Res.string.rmp_new_type_placeholder)
  map.put("rmp_report_admission", Res.string.rmp_report_admission)
  map.put("rmp_report_csv", Res.string.rmp_report_csv)
  map.put("rmp_report_general", Res.string.rmp_report_general)
  map.put("rmp_report_print", Res.string.rmp_report_print)
  map.put("rmp_report_role_change", Res.string.rmp_report_role_change)
  map.put("rmp_report_transfer", Res.string.rmp_report_transfer)
  map.put("rmp_request_new", Res.string.rmp_request_new)
  map.put("rmp_required_actions", Res.string.rmp_required_actions)
  map.put("rmp_required_actions_who", Res.string.rmp_required_actions_who)
  map.put("rmp_required_actions_you", Res.string.rmp_required_actions_you)
  map.put("rmp_retry", Res.string.rmp_retry)
  map.put("rmp_search", Res.string.rmp_search)
  map.put("rmp_sync", Res.string.rmp_sync)
  map.put("rmp_sync_cancel_edit", Res.string.rmp_sync_cancel_edit)
  map.put("rmp_sync_col_actions", Res.string.rmp_sync_col_actions)
  map.put("rmp_sync_col_created_at", Res.string.rmp_sync_col_created_at)
  map.put("rmp_sync_col_destination_director", Res.string.rmp_sync_col_destination_director)
  map.put("rmp_sync_col_destination_director_date", Res.string.rmp_sync_col_destination_director_date)
  map.put("rmp_sync_col_director", Res.string.rmp_sync_col_director)
  map.put("rmp_sync_col_director_date", Res.string.rmp_sync_col_director_date)
  map.put("rmp_sync_col_general_director", Res.string.rmp_sync_col_general_director)
  map.put("rmp_sync_col_general_director_date", Res.string.rmp_sync_col_general_director_date)
  map.put("rmp_sync_col_hr", Res.string.rmp_sync_col_hr)
  map.put("rmp_sync_col_hr_date", Res.string.rmp_sync_col_hr_date)
  map.put("rmp_sync_col_id", Res.string.rmp_sync_col_id)
  map.put("rmp_sync_col_requester", Res.string.rmp_sync_col_requester)
  map.put("rmp_sync_col_status", Res.string.rmp_sync_col_status)
  map.put("rmp_sync_col_type", Res.string.rmp_sync_col_type)
  map.put("rmp_sync_col_unit", Res.string.rmp_sync_col_unit)
  map.put("rmp_sync_confirm_row", Res.string.rmp_sync_confirm_row)
  map.put("rmp_sync_edit_row", Res.string.rmp_sync_edit_row)
  map.put("rmp_sync_empty", Res.string.rmp_sync_empty)
  map.put("rmp_sync_empty_adjusted", Res.string.rmp_sync_empty_adjusted)
  map.put("rmp_sync_hint", Res.string.rmp_sync_hint)
  map.put("rmp_sync_no_suggestion", Res.string.rmp_sync_no_suggestion)
  map.put("rmp_sync_not_applicable", Res.string.rmp_sync_not_applicable)
  map.put("rmp_sync_result", Res.string.rmp_sync_result)
  map.put("rmp_sync_save_row", Res.string.rmp_sync_save_row)
  map.put("rmp_sync_search", Res.string.rmp_sync_search)
  map.put("rmp_sync_status_em_andamento", Res.string.rmp_sync_status_em_andamento)
  map.put("rmp_sync_status_filter", Res.string.rmp_sync_status_filter)
  map.put("rmp_sync_status_finalizados", Res.string.rmp_sync_status_finalizados)
  map.put("rmp_sync_status_rejeitados", Res.string.rmp_sync_status_rejeitados)
  map.put("rmp_sync_status_todos", Res.string.rmp_sync_status_todos)
  map.put("rmp_sync_subtitle", Res.string.rmp_sync_subtitle)
  map.put("rmp_sync_suggested_option", Res.string.rmp_sync_suggested_option)
  map.put("rmp_sync_summary", Res.string.rmp_sync_summary)
  map.put("rmp_sync_tab_adjusted", Res.string.rmp_sync_tab_adjusted)
  map.put("rmp_sync_tab_pending", Res.string.rmp_sync_tab_pending)
  map.put("rmp_sync_title", Res.string.rmp_sync_title)
  map.put("rmp_sync_unlinked", Res.string.rmp_sync_unlinked)
  map.put("rmp_syncing", Res.string.rmp_syncing)
  map.put("rmp_tab_in_progress", Res.string.rmp_tab_in_progress)
  map.put("rmp_tab_unit_history", Res.string.rmp_tab_unit_history)
  map.put("rmp_tab_user_history", Res.string.rmp_tab_user_history)
  map.put("rmp_test_approved", Res.string.rmp_test_approved)
  map.put("rmp_test_convocation", Res.string.rmp_test_convocation)
  map.put("rmp_test_convoke", Res.string.rmp_test_convoke)
  map.put("rmp_test_convoke_title", Res.string.rmp_test_convoke_title)
  map.put("rmp_test_empty", Res.string.rmp_test_empty)
  map.put("rmp_test_failed", Res.string.rmp_test_failed)
  map.put("rmp_test_mark_approved", Res.string.rmp_test_mark_approved)
  map.put("rmp_test_mark_failed", Res.string.rmp_test_mark_failed)
  map.put("rmp_test_pending", Res.string.rmp_test_pending)
  map.put("rmp_test_section", Res.string.rmp_test_section)
  map.put("rmp_test_send", Res.string.rmp_test_send)
  map.put("rmp_test_time_placeholder", Res.string.rmp_test_time_placeholder)
  map.put("rmp_title", Res.string.rmp_title)
  map.put("rmp_totals_status", Res.string.rmp_totals_status)
  map.put("rmp_totals_type", Res.string.rmp_totals_type)
  map.put("rmp_type_all", Res.string.rmp_type_all)
  map.put("rmp_type_alteracao", Res.string.rmp_type_alteracao)
  map.put("rmp_type_desligamento", Res.string.rmp_type_desligamento)
  map.put("rmp_type_filter", Res.string.rmp_type_filter)
  map.put("rmp_type_gratificacao", Res.string.rmp_type_gratificacao)
}
